const languageObj = {
  'Custom': 'مخصص',
  'Original': 'النسخة الأصلية',
  'Resolution': 'الدقة',
  'Frame rate': 'معدل الإطار',
  'The higher the frame rate, the smoother the animation': 'كلما زاد معدل الإطارات ، كانت الرسوم المتحركة أكثر سلاسة.',
  'Start': 'أبدأ',
  'End': 'انتهى',
  'Create GIF': 'إنشاء GIF',
  'Download GIF': 'تنزيل GIF',
  'Create A New One': 'إنشاء واحدة جديدة',
  'Remake GIF': 'إعادة تشكيل GIF',
  'HitPaw Video to GIF Online': 'فيديو إلى GIF عبر الإنترنت HitPaw ',
  'Upload and convert video to GIF without any difficulty': 'قم بتحميل وتحويل الفيديو إلى GIF دون أي صعوبة',
}

export default languageObj